module.exports = __webpack_public_path__ + "static/qrcode-a036d1a46a6e4cb260c5476cb21e99a4.png";